<div class="main-content">
    <!-- Top navbar -->
    <app-navbar [showMenu]="true" [showSearch]="true"></app-navbar>
    
    <!-- Page content -->
    <div class="d-flex w-100">
        <app-sidebar></app-sidebar>

        <div class="admin-container container">
            <router-outlet></router-outlet>
        </div>
    </div>
<!-- 
    <app-footer></app-footer> -->
</div>